import { getFundamentalValue } from '../../../../utils/fundamentals';
import useLocalize from '../../../../utils/hooks/useLocalize';
import DateTime from '../../../common/DateTime';

const i18nKeyPrefix = 'symbol.details.margin.information.';
const mdash = '\u2014';

const LendingFeeDate = ({ fundamentals }) => {
  const localize = useLocalize();

  const utcDateText = getFundamentalValue(
    fundamentals,
    'lendingFee',
    'reportingDate'
  );
  if (!utcDateText) {
    return mdash;
  }

  return (
    <DateTime
      format="MM/DD"
      value={utcDateText}
      suffix={localize(i18nKeyPrefix + 'finalDateFormat.noParenthesis')}
    />
  );
};

export default LendingFeeDate;
